export default {
    username:"xdz",
    password:"123456",
    Viewer:null,
    Count:{//数量信息
        worker:0,
        sxt:2,
        area:3,
        area1:0,
        area2:1,
        area3:2,
        area4:0
    },
    title:"江苏兰陵高分子材料有˚限公司",
    IonToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyNzBlMTYxMC02YTkwLTQ5Y2EtOTU2NC1kNDUwYTg5ZGNjZTkiLCJpZCI6ODc0Mywic2NvcGVzIjpbImFzciIsImdjIl0sImlhdCI6MTU1MjY0MzE0NH0.1hZ8wb3Tq-58PXFaG9o-XPS0U7FmaOMr1qZocIEkIBM",
    Camera:{
        center:[119.395995,31.496646],
        initRectange:[119.3879052,31.4944385,119.3999393,31.5040249],
        maxExtent:[119.3397759,31.4730988,119.4260495,31.5418358],
        height:1320,
        heading:0,
        pitch:-90,
        roll:0
    },
    models://模型6获取
    [
        // {
        //     id:1,
        //     name:'xizhoulong',
        //     modelUrl:"./static/model/xizhoulong.glb",
        //     coors:[119.407801,31.501378],//模型坐标
        //     heading:90, //水平旋转角
        //     pitch:90, // 垂直旋转角
        //     scale:1.0,   //默认1.0
        // },
        {
            id:2,
            name:'dongzhou',
            modelUrl:"/v1/uploadFiles/files/model/wuweiyiti/tileset.json", // "./static/model/3dtiles/3dtiles_1/tileset.json"
            // modelUrl:"/uploadFiles/company/xizhoulong.gltf",
            coors:[119.396131556479,31.4976925966233],
            heading:90,
            pitch:90,
            scale: 0.001,   //默认1.0
            rotateZ:75.4

        }

    ],
    base_url:"http://localhost:8082/WHHG/",//基地址
    // base_url:"http://localhost:8082/WHHG",//基地址

}
